var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{key:_vm.$store.getters['resource/currentResource'].key,staticClass:"white-container"},[_c('promo-view',{attrs:{"params":this.$route.params},on:{"save":_vm.savePromo}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }